export default function parseNftsToUseMaths(
  nfts: { valuation: bigint; ltv: bigint }[]
) {
  return nfts.map(({ valuation, ltv }) => ({
    valuation: valuation.toString(),
    ltv: ltv.toString(),
  }));
}
